import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';

interface SectionHeaderProps {
  title: string;
  description?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, description }) => {
  return (
    <Box borderBottom="1px solid" borderColor="neutral.200" mb="24">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Text as="h2" fontSize="h4" fontWeight={600} mb="8">
            {title}
          </Text>

          {description && (
            <Text color="neutral.600" mb="24">
              {description}
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};
